import _objectSpread from'@babel/runtime/helpers/objectSpread2';import {useMemo}from'react';import {useHistory}from'react-router-dom';import usePathBuilder from'./usePathBuilder.js';/**
 * Returns a CIAM aware wrapper of the react-router history object
 *
 * The `.push()` and `.replace()` methods will properly take the realm into account.
 */
function useCIAMHistory() {
  var history = useHistory();
  var pathBuilder = usePathBuilder();
  var ciamHistory = useMemo(function () {
    var push = function push(path) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var ciamPath = pathBuilder(path);
      history.push(ciamPath, state);
    };
    var replace = function replace(path) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var ciamPath = pathBuilder(path);
      history.replace(ciamPath, state);
    };
    var ciamWrappedHistory = _objectSpread(_objectSpread({}, history), {}, {
      push: push,
      replace: replace
    });
    return ciamWrappedHistory;
  }, [history, pathBuilder]);
  return ciamHistory;
}export{useCIAMHistory as default};